export default "__VITE_ASSET__C6C1$TtO__"